<template>
  <div>
    <AnnouncementsList />
  </div>
</template>

<script>
import AnnouncementsList from '../components/AnnouncementsList.vue';
export default {
  components: {
    AnnouncementsList,
  },
};
</script>
